/* MUSCLEXPRESS — front del catálogo.
   Una sola fuente de verdad: datos/catalogo.json.
   El carrito vive en localStorage y termina en un mensaje de WhatsApp. */

const MX = {
  // ── ÚNICO LUGAR QUE HAY QUE TOCAR ───────────────────────────
  // Formato: 52 + 10 dígitos. Si WhatsApp llegara a rebotar el enlace,
  // probar con 521 al inicio (521 3332295540): algunos números viejos de
  // México siguen registrados con el 1.
  whatsapp: '523332295540',           // ← pedidos y dudas  ·  +52 33 3229 5540
  whatsappMayoreo: '523332295540',    // ← mayoreo
  // ────────────────────────────────────────────────────────────
  datos: window.MX_DATOS,
  dat: 18,  // ← sube este número cada vez que cambien precios o promociones
  // Sube este número al cambiar fotos de producto: sin esto el navegador
  // sigue mostrando la imagen vieja aunque el archivo ya sea otro.
  rev: 13,
  cart: [],
  cat: null,
};

const $  = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];

const money = n => '$' + n.toLocaleString('es-MX');

/* Buscar sin acentos. Quien escribe "masteron" o "primobolan" no pone la
   tilde, y sin esto no encontraba "Masterón" ni "Primobolán". */
const plano = t => (t || '').toLowerCase()
  .normalize('NFD').replace(/[̀-ͯ]/g, '');
const imgSrc = (slug) => `${window.MX_CDN}/${slug}.jpg`;

// Precio por pieza. Nuestras cajas traen más que las de enfrente, así que el
// número que conviene que el cliente compare no es el de la caja.
const porUnidad = p => {
  if (!p.precio || !p.unidades) return '';
  const v = p.precio / p.unidades;
  return `$${v.toFixed(2)} por ${p.unidad}`;
};

/* Un solo porcentaje en toda la tienda: 10 %. El combo ya lo trae puesto y el
   pedido suelto lo gana a las 3 piezas. Así ninguna de las dos rutas sale
   perdiendo y el precio que se anuncia es el que se cobra.
   Una sola regla en todo el sitio — en la ficha, en el carrito y en el
   mensaje de WhatsApp sale el mismo número. */
const promo = () => (MX.cat && MX.cat.promo) || { piezas: 3, descuento: 0.2 };

function piezasCarrito() {
  return MX.cart.reduce((a, l) => {
    if (l.stack) {
      const st = ((MX.cat && MX.cat.stacks) || []).find(x => x.slug === l.stack);
      return a + (st ? st.items.length * l.n : l.n);
    }
    return a + l.n;
  }, 0);
}
const hayPromo = n => n >= promo().piezas;
const conPromo = v => Math.round(v * (1 - promo().descuento));
const pct = () => Math.round(promo().descuento * 100);

/* ---------- datos ---------- */
async function catalogo() {
  if (MX.cat) return MX.cat;
  const base = location.pathname.includes('/') ? '' : '';
  const r = await fetch(MX.datos);
  if (!r.ok) throw new Error('No se pudo leer el catálogo');
  MX.cat = await r.json();
  MX.cat.index = Object.fromEntries(MX.cat.productos.map(p => [p.slug, p]));
  return MX.cat;
}

/* ---------- tarjeta ---------- */
function cardHTML(p, cat) {
  const marca = cat.marcas[p.marca].nombre;
  const precio = p.precio
    ? `<span class="price"><span class="cur">MXN</span>${p.precio.toLocaleString('es-MX')}</span>`
    : `<span class="price-ask">Precio por WhatsApp</span>`;
  const add = p.precio
    ? `<button class="add" data-add="${p.slug}" aria-label="Agregar ${p.nombre}">+</button>`
    : '';
  return `
  <a class="card" href="/products/${p.slug}">
    <div class="card-img"><img src="${imgSrc(p.slug)}" alt="${p.nombre} — ${p.sustancia}, ${p.concentracion}" loading="lazy" width="300" height="300"></div>
    <div class="card-body">
      <span class="brand">${marca}</span>
      <h3>${p.nombre}</h3>
      <p class="sust">${p.sustancia}</p>
      <div class="spec"><span>${p.concentracion}</span><span>${p.presentacion}</span></div>
      <div class="card-foot">
        <span class="precio-bloque">${precio}${porUnidad(p) ? `<span class="unit">${porUnidad(p)}</span>` : ''}</span>${add}
      </div>
    </div>
  </a>`;
}

/* Stacks. Lo que la gente busca no es "oxandrolona": es un objetivo. El stack
   traduce el catálogo a eso, y de paso sube el ticket — tres productos con
   descuento se venden más fácil que tres decisiones sueltas. */
function stackHTML(st, cat) {
  const items = st.items.map(sl => cat.index[sl]).filter(Boolean);
  return `
  <article class="stack">
    <div class="stack-fotos">
      ${items.map(p => `<img src="${imgSrc(p.slug)}" alt="${p.nombre}" loading="lazy">`).join('')}
    </div>
    <div class="stack-body">
      <span class="stack-gancho">${st.gancho}</span>
      <h3>PAQUETE ${st.nombre}</h3>
      <p class="stack-desc">${st.desc}</p>
      <ul class="stack-items">
        ${items.map(p => `<li><a href="/products/${p.slug}">${p.nombre}</a> <span>${p.concentracion}</span></li>`).join('')}
      </ul>
      <div class="stack-precio">
        <div>
          <span class="antes">${money(st.precio_suelto)}</span>
          <span class="price"><span class="cur">MXN</span>${st.precio_promo.toLocaleString('es-MX')}</span>
          <span class="unit">con el ${pct()} % del combo · ${st.items.length} productos</span>
        </div>
        <button class="btn btn-primary" data-stack="${st.slug}">Agregar paquete</button>
      </div>
    </div>
  </article>`;
}

async function pintaStacks(sel, limite) {
  const cat = await catalogo();
  const c = $(sel); if (!c || !cat.stacks) return;
  c.innerHTML = cat.stacks.slice(0, limite || 99).map(st => stackHTML(st, cat)).join('');
}

/* ---------- home ---------- */
async function initHome() {
  const cat = await catalogo();
  const cont = $('#destacados');
  if (cont) {
    const orden = ['mounjarox-15mg', 'retatrutide-12mg', 'bpc-157-10mg', 'tb-500-10mg',
                   'ipamorelin-10mg', 'defense-cellular-longevity-30', 'mind-calm-90',
                   'performance-peptona-120'];
    const items = orden.map(s => cat.index[s]).filter(Boolean);
    cont.innerHTML = items.map(p => cardHTML(p, cat)).join('');
  }
  $$('[data-cuenta]').forEach(el => {
    const c = el.dataset.cuenta;
    el.textContent = cat.productos.filter(p => p.categoria === c).length;
  });
}

/* ---------- catálogo ---------- */
async function initCatalogo() {
  const cat = await catalogo();
  const grid = $('#grid'), filtros = $('#filtros'), buscar = $('#buscar');
  const labs = $('#labs');
  const _col = {'post-ciclo':'postciclo'};
  let activa = (window.MX_COL ? (_col[window.MX_COL] || window.MX_COL) : null)
    || new URLSearchParams(location.search).get('c') || 'todo';
  let lab = new URLSearchParams(location.search).get('m') || 'todos';

  filtros.innerHTML =
    `<button class="chip" data-c="todo">Todo</button>` +
    Object.entries(cat.categorias)
      .map(([k, v]) => `<button class="chip" data-c="${k}">${v}</button>`).join('');

  // Segundo eje: por laboratorio. Mucha gente del nicho compra por marca.
  if (labs) labs.innerHTML =
    `<span class="filtro-lbl">Laboratorio</span>` +
    `<button class="chip chip-sm" data-m="todos">Todos</button>` +
    Object.entries(cat.marcas)
      .map(([k, v]) => `<button class="chip chip-sm" data-m="${k}">${v.nombre}</button>`).join('');

  function pinta() {
    const q = plano((buscar.value || '').trim());
    const items = cat.productos.filter(p => {
      const okCat = activa === 'todo' || p.categoria === activa;
      const okLab = lab === 'todos' || p.marca === lab;
      const okQ = !q || plano([p.nombre, p.sustancia, p.concentracion,
                              cat.marcas[p.marca].nombre, p.equivalencia || '',
                              p.presentacion].join(' ')).includes(q);
      return okCat && okLab && okQ;
    });
    grid.innerHTML = items.length
      ? items.map(p => cardHTML(p, cat)).join('')
      : `<p class="empty" style="grid-column:1/-1;background:var(--surface)">Nada coincide con “${buscar.value}”.</p>`;
    $('#cuenta').textContent = items.length + (items.length === 1 ? ' producto' : ' productos');
    listaSEO(items, cat);
    $$('.chip', filtros).forEach(b => b.setAttribute('aria-pressed', b.dataset.c === activa));
    if (labs) $$('.chip', labs).forEach(b => b.setAttribute('aria-pressed', b.dataset.m === lab));
  }

  filtros.addEventListener('click', e => {
    const b = e.target.closest('.chip'); if (!b) return;
    activa = b.dataset.c;
    history.replaceState({}, '', activa === 'todo' ? 'catalogo.html' : `catalogo.html?c=${activa}`);
    pinta();
  });
  labs?.addEventListener('click', e => {
    const b = e.target.closest('.chip'); if (!b) return;
    lab = b.dataset.m; pinta();
  });
  buscar.addEventListener('input', pinta);
  pinta();
}


const SITIO = 'https://muscleexpress.shop';

/* Buscadores y redes: título, descripción, canonical y datos estructurados
   de cada producto. Sin esto, las 37 fichas son invisibles en Google. */
function seoProducto(p, cat) {
  // La gente no busca "mounjaroX", busca "tirzepatida precio". Por eso la
  // sustancia va en el título aunque el nombre comercial sea otro, y el precio
  // también: en las búsquedas con "precio" es lo que se lleva el clic.
  const mismo = p.nombre.toLowerCase().includes((p.sustancia || '').toLowerCase());
  const clave = mismo ? p.nombre : `${p.nombre} (${p.sustancia})`;
  const desc = `${clave}, ${p.concentracion}. ${p.presentacion}. ` +
               `${cat.marcas[p.marca].nombre}. ${p.precio ? money(p.precio) + ' MXN. ' : ''}` +
               `${envioGratis()}. Sale en 72 h, llega en 3 a 5 días hábiles.`;
  document.title = `${clave} ${p.concentracion}` +
                   `${p.precio ? ' — ' + money(p.precio) : ''} | MUSCLEXPRESS`;
  const set = (sel, attr, val) => {
    let el = document.head.querySelector(sel);
    if (!el) {
      el = document.createElement(sel.startsWith('link') ? 'link' : 'meta');
      sel.match(/\[(.+?)=["'](.+?)["']\]/) && el.setAttribute(RegExp.$1, RegExp.$2);
      document.head.appendChild(el);
    }
    el.setAttribute(attr, val);
  };
  const foto = `${SITIO}/${imgSrc(p.slug).split('?')[0]}`;
  set('meta[name="description"]', 'content', desc);
  set('meta[property="og:title"]', 'content', `${clave} — ${p.concentracion}`);
  set('meta[property="og:description"]', 'content', desc);
  set('meta[property="og:type"]', 'content', 'product');
  // Lo que más se comparte de este sitio es una ficha por WhatsApp. Si la
  // miniatura es el logo genérico en vez de la caja, el mensaje no vende.
  set('meta[property="og:image"]', 'content', foto);
  set('meta[property="og:image:alt"]', 'content', `${p.nombre} — ${p.sustancia}`);
  set('meta[name="twitter:image"]', 'content', foto);
  if (p.precio) {
    set('meta[property="product:price:amount"]', 'content', String(p.precio));
    set('meta[property="product:price:currency"]', 'content', 'MXN');
  }
  set('link[rel="canonical"]', 'href', `${SITIO}//products/${p.slug}`);

  const ld = document.createElement('script');
  ld.type = 'application/ld+json';
  ld.textContent = JSON.stringify({
    '@context': 'https://schema.org', '@type': 'Product',
    name: p.nombre, sku: p.slug.toUpperCase(), description: desc,
    image: `${SITIO}/${imgSrc(p.slug).split('?')[0]}`,
    brand: { '@type': 'Brand', name: cat.marcas[p.marca].nombre },
    category: cat.categorias[p.categoria],
    offers: {
      '@type': 'Offer', price: p.precio, priceCurrency: 'MXN',
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition',
      priceValidUntil: new Date(Date.now() + 15552000000).toISOString().slice(0, 10),
      url: `${SITIO}//products/${p.slug}`,
      seller: { '@type': 'Organization', name: 'MUSCLEXPRESS' },
      shippingDetails: {
        '@type': 'OfferShippingDetails',
        shippingDestination: { '@type': 'DefinedRegion', addressCountry: 'MX' },
        deliveryTime: {
          '@type': 'ShippingDeliveryTime',
          transitTime: { '@type': 'QuantitativeValue', minValue: 1, maxValue: 3, unitCode: 'DAY' },
        },
      },
    },
  });
  document.head.appendChild(ld);

  // Migas de pan: Google las pinta en el resultado en vez de la URL cruda.
  const migas = document.createElement('script');
  migas.type = 'application/ld+json';
  migas.textContent = JSON.stringify({
    '@context': 'https://schema.org', '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: `${SITIO}/` },
      { '@type': 'ListItem', position: 2, name: 'Catálogo', item: `${SITIO}/catalogo.html` },
      { '@type': 'ListItem', position: 3, name: cat.categorias[p.categoria],
        item: `${SITIO}/catalogo.html?c=${p.categoria}` },
      { '@type': 'ListItem', position: 4, name: p.nombre },
    ],
  });
  document.head.appendChild(migas);
}

/* El catálogo es una lista de ofertas, no un muro de texto. Declararlo como
   ItemList deja que Google entienda qué hay y a cuánto, y es lo que habilita
   el carrusel de productos en los resultados. */
function listaSEO(items, cat) {
  let el = document.getElementById('ld-lista');
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = 'ld-lista';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify({
    '@context': 'https://schema.org', '@type': 'ItemList',
    numberOfItems: items.length,
    itemListElement: items.slice(0, 60).map((p, i) => ({
      '@type': 'ListItem', position: i + 1,
      item: {
        '@type': 'Product', name: p.nombre, sku: p.slug.toUpperCase(),
        image: `${SITIO}/${imgSrc(p.slug).split('?')[0]}`,
        brand: { '@type': 'Brand', name: cat.marcas[p.marca].nombre },
        url: `${SITIO}//products/${p.slug}`,
        offers: p.precio ? {
          '@type': 'Offer', price: p.precio, priceCurrency: 'MXN',
          availability: 'https://schema.org/InStock',
        } : undefined,
      },
    })),
  });
}

/* Tres opciones, no siete: más de tres y la gente no elige. La de 3 es la
   que activa la promoción, y por eso va marcada. */
/* Envío: a partir de 2 piezas va por nuestra cuenta. Es el empujón más barato
   que hay para pasar de una pieza a dos, y no toca el precio de lista. */
const envioGratis = () =>
  (MX.cat && MX.cat.envio && MX.cat.envio.texto_gratis) || 'Envío gratis desde 2 piezas';
const piezasEnvio = () => (MX.cat && MX.cat.envio && MX.cat.envio.gratis_desde) || 2;

/* "En qué ayuda" va sólo en péptidos. En esteroides no: quien los busca ya sabe
   para qué son, y ahí sí sobra la promesa. */
function favoreceHTML(p) {
  if (!p.favorece || !p.favorece.length) return '';
  return `
    <section class="favorece">
      <h2>En qué ayuda</h2>
      <ul>${p.favorece.map(f => `<li>${f}</li>`).join('')}</ul>
      ${p.favorece_nota ? `<p class="fav-nota">${p.favorece_nota}</p>` : ''}
    </section>`;
}

function paquetes(p) {
  const filas = [1, 2, 3].map(n => {
    const bruto = p.precio * n;
    const total = hayPromo(n) ? conPromo(bruto) : bruto;
    const ahorro = bruto - total;
    return `
      <button type="button" class="pack" data-add="${p.slug}" data-n="${n}" ${n === 3 ? 'data-mejor' : ''}>
        <span class="pack-n">${n} ${n === 1 ? 'pieza' : 'piezas'}</span>
        <span class="pack-u">${money(total)}</span>
        <span class="pack-a">${[ahorro ? 'ahorras ' + money(ahorro) : '', n >= piezasEnvio() ? 'envío gratis' : ''].filter(Boolean).join(' · ') || 'sin descuento'}</span>
      </button>`;
  }).join('');
  return `<div class="packs"><p class="packs-lbl">Desde 2 piezas el envío es gratis · desde 3 se descuenta ${pct()} %</p><div class="packs-row">${filas}</div></div>`;
}

/* Compartir. En México el producto se recomienda por WhatsApp, no por Twitter:
   ese botón va primero y los demás casi de cortesía. */
function compartir(p) {
  const url = `${SITIO}//products/${p.slug}`;
  const txt = `${p.nombre} — ${p.concentracion} · ${money(p.precio || 0)}`;
  return `
  <div class="share">
    <span class="share-lbl">Compartir</span>
    <a href="https://wa.me/?text=${encodeURIComponent(txt + ' ' + url)}" target="_blank" rel="noopener">WhatsApp</a>
    <a href="https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}" target="_blank" rel="noopener">Facebook</a>
    <button type="button" data-copiar="${url}">Copiar enlace</button>
  </div>`;
}

/* Enlaces internos: de una ficha siempre se puede saltar a cuatro productos
   de la misma categoría. Reduce el callejón sin salida y le da a Google
   caminos para llegar a las 37 fichas. */
function relacionados(p, cat) {
  const otros = cat.productos.filter(x => x.categoria === p.categoria && x.slug !== p.slug).slice(0, 4);
  if (!otros.length) return '';
  return `
  <section class="sec" style="padding-bottom:0">
    <div class="sec-head">
      <h2 style="font-size:1.4rem">Más en ${cat.categorias[p.categoria].toLowerCase()}</h2>
      <a class="count" href="catalogo.html?c=${p.categoria}" style="text-decoration:none">Ver todos →</a>
    </div>
    <div class="grid">${otros.map(x => cardHTML(x, cat)).join('')}</div>
  </section>`;
}

/* Barra fija en móvil: el precio y el botón de comprar siempre a la vista,
   sin tener que regresar hasta arriba. */
function barraMovil(p) {
  if (!p.precio) return;
  const b = document.createElement('div');
  b.className = 'sticky-buy';
  b.innerHTML = `
    <div class="sb-precio">
      <span class="price"><span class="cur">MXN</span>${p.precio.toLocaleString('es-MX')}</span>
      <span class="unit">3 piezas = ${pct()} % menos</span>
    </div>
    <button class="btn btn-primary" data-add="${p.slug}">Agregar</button>`;
  document.body.appendChild(b);
  document.body.classList.add('con-sticky');
}

/* ---------- ficha ---------- */
async function initProducto() {
  const cat = await catalogo();
  const slug = window.MX_SLUG || new URLSearchParams(location.search).get('p');
  const p = cat.index[slug];
  const root = $('#ficha');
  if (!p) { root.innerHTML = `<p class="empty">Ese producto no existe. <a href="catalogo.html">Ver catálogo</a></p>`; return; }

  seoProducto(p, cat);
  const vistas = p.fotos || 1;
  const filas = [
    ['Sustancia', p.sustancia, 'txt'],
    ['Concentración', p.concentracion],
    ['Presentación', p.presentacion],
    p.via && ['Vía', p.via, 'txt'],
    p.equivalencia && ['Equivalencia comercial', p.equivalencia, 'txt'],
    p.conservacion && ['Conservación', p.conservacion, 'txt'],
    ['Marca', cat.marcas[p.marca].nombre, 'txt'],
    ['Origen', cat.marcas[p.marca].origen, 'txt'],
    p.pureza_declarada && ['Pureza declarada', p.pureza_declarada],
    ['Lote', p.lote || 'Asignado al despachar'],
  ].filter(Boolean);

  root.innerHTML = `
    <div class="ficha-media">
      <div class="big"><img id="big" src="${imgSrc(p.slug)}" alt="${p.nombre} — ${p.sustancia}, ${p.concentracion}. ${p.presentacion}" width="600" height="600"></div>
      ${vistas > 1 ? `<div class="thumbs">${Array.from({ length: vistas }, (_, i) =>
        `<button data-i="${i}" aria-pressed="${i === 0}"><img src="${imgSrc(p.slug, i)}" alt="${p.nombre}, vista ${i + 1}"></button>`).join('')}</div>` : ''}
    </div>
    <div>
      <p class="brandline">${cat.marcas[p.marca].nombre} · ${cat.categorias[p.categoria]}</p>
      <h1>${p.nombre}</h1>
      <p class="sust-big">${p.sustancia}</p>
      ${p.precio
        ? `<span class="price"><span class="cur">MXN</span>${p.precio.toLocaleString('es-MX')}</span>
           <p class="unit-big">${porUnidad(p) ? porUnidad(p) + ' · ' : ''}Precio final. ${envioGratis()}</p>`
        : `<p class="price-ask" style="font-size:1rem;margin:22px 0 0">Precio por WhatsApp</p>`}
      <div class="buy">
        ${p.precio ? `
        <div class="qty">
          <button data-q="-1" aria-label="Menos">−</button>
          <input id="qty" value="1" inputmode="numeric" aria-label="Cantidad">
          <button data-q="1" aria-label="Más">+</button>
        </div>
        <button class="btn btn-primary" id="agregar">Agregar al pedido</button>` : ''}
        <a class="btn ${p.precio ? 'btn-ink' : 'btn-primary'}" id="wa" href="#">Preguntar por WhatsApp</a>
      </div>
      <table class="spec-table">
        <caption class="sr">Ficha técnica</caption>
        ${filas.map(([k, v, c]) => `<tr><th scope="row">${k}</th><td class="${c || ''}">${v}</td></tr>`).join('')}
      </table>
      ${favoreceHTML(p)}
      ${p.precio ? paquetes(p) : ''}
      ${compartir(p)}
      <p class="uso"><strong>Uso responsable.</strong> Producto dirigido a personas mayores de edad.
      Consulta a un profesional de la salud antes de utilizarlo.</p>
    </div>`;

  root.insertAdjacentHTML('afterend', relacionados(p, cat));
  barraMovil(p);

  $('#wa').href = `https://wa.me/${MX.whatsapp}?text=` +
    encodeURIComponent(`Hola, información sobre ${p.nombre} (${p.concentracion}) — muscleexpress.shop`);

  root.addEventListener('click', e => {
    const t = e.target.closest('.thumbs button');
    if (t) {
      $('#big').src = imgSrc(p.slug, +t.dataset.i);
      $$('.thumbs button', root).forEach(b => b.setAttribute('aria-pressed', b === t));
    }
    const q = e.target.closest('[data-q]');
    if (q) {
      const i = $('#qty');
      i.value = Math.max(1, (parseInt(i.value) || 1) + (+q.dataset.q));
    }
    if (e.target.id === 'agregar') addItem(p.slug, parseInt($('#qty').value) || 1);
  });
}

/* ---------- carrito ---------- */
function loadCart() {
  try { MX.cart = JSON.parse(localStorage.getItem('mx_cart') || '[]'); }
  catch { MX.cart = []; }
}
function saveCart() {
  try { localStorage.setItem('mx_cart', JSON.stringify(MX.cart)); } catch {}
  paintCart();
}
/* Confirmación discreta. Abrir el cajón a la fuerza en cada "+" cortaba la
   navegación: para meter un segundo producto había que cerrarlo antes. */
let avisoT;
function aviso(texto) {
  let a = $('#aviso');
  if (!a) {
    a = document.createElement('div');
    a.id = 'aviso';
    a.className = 'aviso';
    a.setAttribute('role', 'status');
    a.setAttribute('aria-live', 'polite');
    document.body.appendChild(a);
  }
  a.innerHTML = '';
  const t = document.createElement('span');
  t.textContent = texto;
  const b = document.createElement('button');
  b.type = 'button';
  b.setAttribute('data-open-cart', '');
  b.textContent = 'Ver pedido';
  a.append(t, b);
  a.classList.add('on');
  clearTimeout(avisoT);
  avisoT = setTimeout(() => a.classList.remove('on'), 3600);
}

const piezasEnCarrito = () => MX.cart.reduce((s, l) => s + l.n, 0);

async function addItem(slug, n = 1) {
  const l = MX.cart.find(x => x.slug === slug);
  l ? (l.n += n) : MX.cart.push({ slug, n });
  saveCart();
  aviso(`Agregado · ${piezasEnCarrito()} en tu pedido`);
}
async function addStack(slug) {
  const l = MX.cart.find(x => x.stack === slug);
  l ? (l.n += 1) : MX.cart.push({ stack: slug, n: 1 });
  saveCart();
  aviso(`Paquete agregado · ${piezasEnCarrito()} en tu pedido`);
}
function removeItem(slug) {
  MX.cart = MX.cart.filter(x => (x.stack || x.slug) !== slug);
  saveCart();
}
function openCart(v) {
  $('#drawer').classList.toggle('open', v);
  $('#scrim').classList.toggle('open', v);
}

async function paintCart() {
  const cat = await catalogo();
  const body = $('#drawer-body'), n = MX.cart.reduce((a, x) => a + x.n, 0);
  $$('[data-cart-n]').forEach(e => e.textContent = n);

  if (!MX.cart.length) {
    body.innerHTML = `<p class="empty">Tu pedido está vacío.</p>`;
    $('#total').textContent = money(0);
    $('#pedir').setAttribute('disabled', '');
    return;
  }
  let total = 0, suelto = 0;
  body.innerHTML = MX.cart.map(l => {
    if (l.stack) {
      const st = (cat.stacks || []).find(x => x.slug === l.stack);
      if (!st) return '';
      const sub = st.precio_promo * l.n;
      total += sub;
      return `<div class="line">
        <img src="${imgSrc(st.items[0])}" alt="">
        <div class="info">
          <div class="nm">PAQUETE ${st.nombre}</div>
          <div class="mt">${l.n} × ${money(st.precio_promo)} · ${st.items.length} productos · ${pct()} % ya aplicado</div>
          <button class="rm" data-rm="${st.slug}">Quitar</button>
        </div>
        <span class="price">${money(sub)}</span>
      </div>`;
    }
    const p = cat.index[l.slug]; if (!p) return '';
    suelto += (p.precio || 0) * l.n;
    const sub = (p.precio || 0) * l.n;
    total += sub;
    return `<div class="line">
      <img src="${imgSrc(p.slug)}" alt="">
      <div class="info">
        <div class="nm">${p.nombre}</div>
        <div class="mt">${l.n} × ${money(p.precio || 0)} · ${p.concentracion}</div>
        <button class="rm" data-rm="${p.slug}">Quitar</button>
      </div>
      <span class="price">${money(sub)}</span>
    </div>`;
  }).join('');
  const piezas = piezasCarrito();
  const aplica = hayPromo(piezas) && suelto > 0;
  const desc = aplica ? suelto - conPromo(suelto) : 0;
  const final = total - desc;
  const dto = $('#dto');
  if (dto) {
    dto.hidden = !aplica;
    dto.innerHTML = aplica
      ? `<span>Descuento por ${piezas} piezas · ${pct()} %</span><span>−${money(desc)}</span>`
      : suelto === 0
        ? `<span class="falta">Tu combo ya trae el ${pct()} % de descuento</span>`
        : `<span class="falta">Te faltan ${promo().piezas - piezas} pieza(s) para el ${pct()} % de descuento</span>`;
    dto.hidden = false;
    dto.classList.toggle('activo', aplica || suelto === 0);
    let nota = document.getElementById('envio-nota');
    if (!nota) {
      nota = document.createElement('p');
      nota.id = 'envio-nota';
      nota.className = 'envio-nota';
      dto.insertAdjacentElement('afterend', nota);
    }
    const gratis = piezas >= piezasEnvio();
    nota.textContent = gratis
      ? 'Envío gratis incluido'
      : `Agrega ${piezasEnvio() - piezas} pieza más y el envío es gratis`;
    nota.classList.toggle('activo', gratis);
  }
  $('#total').textContent = money(final);
  $('#pedir').removeAttribute('disabled');
}

function permalinkCheckout() {
  /* Shopify acepta /cart/<variante>:<cantidad>,... y abre el checkout con
     todo dentro. Es un enlace, no una API: no hay nada que se pueda romper
     a medio camino. */
  // Ojo: los paquetes se guardan como {stack: slug}, los sueltos como {slug}.
  // Leer solo l.slug dejaba el checkout vacío cuando el pedido era de paquetes.
  const partes = MX.cart.map(l => {
    const id = l.stack || l.slug;
    const it = MX.cat.index[id] || MX.cat.stacks.find(s => s.slug === id);
    return it && it.variante ? `${it.variante}:${l.n}` : null;
  }).filter(Boolean);
  return { url: partes.length ? '/cart/' + partes.join(',') : null,
           completo: partes.length === MX.cart.length };
}

function irACheckout() {
  const { url, completo } = permalinkCheckout();
  // Antes que mandar medio pedido al pago, avisamos y no movemos nada.
  if (!url || !completo) {
    aviso('No pudimos armar el pago. Escríbenos por WhatsApp y lo cerramos.');
    return;
  }
  location.href = url;
}

async function pedirWhatsApp() {
  const cat = await catalogo();
  const folio = 'MX-' + new Date().toISOString().slice(2, 10).replace(/-/g, '') + '-' +
                Math.floor(Math.random() * 900 + 100);
  let total = 0, suelto = 0;
  const lineas = MX.cart.map(l => {
    if (l.stack) {
      const st = (cat.stacks || []).find(x => x.slug === l.stack);
      total += st.precio_promo * l.n;
      const dentro = st.items.map(sl => '   · ' + cat.index[sl].nombre).join(String.fromCharCode(10));
      return `${l.n} × PAQUETE ${st.nombre} — ${money(st.precio_promo * l.n)}
${dentro}`;
    }
    const p = cat.index[l.slug];
    total += p.precio * l.n;
    suelto += p.precio * l.n;
    return `${l.n} × ${p.nombre} — ${p.concentracion} — ${money(p.precio * l.n)}`;
  });
  const piezas = piezasCarrito();
  const aplica = hayPromo(piezas) && suelto > 0;
  const desc = aplica ? suelto - conPromo(suelto) : 0;
  const final = total - desc;
  const txt = [
    `Pedido ${folio}`, '',
    ...lineas, '',
    ...(aplica ? [`Subtotal: ${money(total)}`,
                  `Descuento por ${piezas} piezas: −${money(desc)} (${pct()}%)`] : []),
    `Total: ${money(final)} MXN`,
    piezas >= piezasEnvio() ? 'Envío: gratis' : 'Envío: se cotiza aparte', '',
    'Nombre:', 'Ciudad y CP:', 'Forma de pago:',
  ].join('\n');
  window.open(`https://wa.me/${MX.whatsapp}?text=${encodeURIComponent(txt)}`, '_blank', 'noopener');

  // Lo último que ve la persona es lo que recuerda. En vez de dejar el carrito
  // colgado, se confirma qué pasó y qué sigue.
  $('#drawer-body').innerHTML = `
    <div class="gracias">
      <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="var(--cyan-text)" stroke-width="2">
        <path d="M20 6 9 17l-5-5"/>
      </svg>
      <h3>Se abrió tu WhatsApp</h3>
      <p>Tu pedido va con el folio <strong>${folio}</strong>. Guárdalo: con ese número le damos seguimiento.</p>
      <p class="chico">Si no se abrió solo, escríbenos y pásanos el folio.</p>
      <a class="btn btn-ink btn-wide" href="https://wa.me/${MX.whatsapp}?text=${encodeURIComponent('Hola, mi folio es ' + folio)}" target="_blank" rel="noopener">Abrir WhatsApp otra vez</a>
      <button class="btn btn-wide" id="seguir" style="background:transparent;color:var(--cyan-text);padding-left:0;padding-right:0">Seguir viendo el catálogo</button>
    </div>`;
  $('#seguir').onclick = () => openCart(false);
  $('#pedir').setAttribute('disabled', '');
}

/* Cintillo de confianza. Son las tres dudas que frenan una primera compra en
   este nicho: cómo pago, cuándo llega, y si hay descuento por llevar más.
   Rota cada 5 s para que quepan las tres sin saturar la pantalla. */
function cintillo() {
  const barra = $('#cintillo'); if (!barra) return;
  const cat = MX.cat || {};
  const msgs = [
    'Aceptamos Mercado Pago · Transferencia · Depósito · OXXO',
    (cat.envio && cat.envio.texto) || 'Envío en 72 horas a cualquier domicilio en México',
    (cat.envio && cat.envio.texto_gratis) || 'Envío gratis desde 2 piezas',
    (cat.promo && cat.promo.texto) || '3 productos o más: 10 % de descuento en todo tu pedido',
  ];
  let i = 0;
  const pinta = () => {
    barra.textContent = msgs[i % msgs.length];
    barra.classList.remove('cin-in');
    void barra.offsetWidth;
    barra.classList.add('cin-in');
    i++;
  };
  pinta();
  setInterval(pinta, 5000);
}

/* ---------- botón flotante de WhatsApp ----------
   Se inyecta desde aquí para que exista en todas las páginas sin repetir
   marcado. En móvil la mitad de la gente de este nicho quiere hablar con una
   persona antes de transferir: si el botón no está a la vista, se van. */
function botonWhatsApp() {
  const a = document.createElement('a');
  a.className = 'wa-float';
  a.target = '_blank';
  a.rel = 'noopener';
  a.href = `https://wa.me/${MX.whatsapp}?text=` +
    encodeURIComponent('Hola, vengo de muscleexpress.shop. Quiero información sobre:');
  a.setAttribute('aria-label', 'Escribir por WhatsApp');
  a.innerHTML = `
    <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
      <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.08-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.48-1.75-1.65-2.05-.17-.3-.02-.46.13-.6.14-.14.3-.36.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35z"/>
      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.96L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.15a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.23 8.24-8.23 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.82c0 4.54-3.69 8.23-8.23 8.23z"/>
    </svg>
    <span>Escríbenos</span>`;
  document.body.appendChild(a);
}

/* ---------- arranque ---------- */
document.addEventListener('DOMContentLoaded', () => {
  loadCart();
  botonWhatsApp();
  catalogo().then(cintillo).catch(() => {});

  $('#burger')?.addEventListener('click', () => $('#nav').classList.toggle('open'));
  $('#scrim')?.addEventListener('click', () => openCart(false));
  $('#cerrar')?.addEventListener('click', () => openCart(false));
  // Delegado: el botón "Ver pedido" del aviso se crea después de este init.
  document.addEventListener('click', e => {
    if (e.target.closest('[data-open-cart]')) openCart(true);
  });
  $('#pedir')?.addEventListener('click', irACheckout);
  $('#drawer-body')?.addEventListener('click', e => {
    const b = e.target.closest('[data-rm]'); if (b) removeItem(b.dataset.rm);
  });
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-add]');
    if (b) { e.preventDefault(); addItem(b.dataset.add, parseInt(b.dataset.n) || 1); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') openCart(false); });
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-copiar]');
    if (!b) return;
    e.preventDefault();
    try { await navigator.clipboard.writeText(b.dataset.copiar); b.textContent = 'Copiado'; }
    catch { b.textContent = b.dataset.copiar; }
    setTimeout(() => { b.textContent = 'Copiar enlace'; }, 2200);
  });

  $$('[data-wa]').forEach(a => {
    a.href = `https://wa.me/${a.dataset.wa === 'mayoreo' ? MX.whatsappMayoreo : MX.whatsapp}` +
      `?text=${encodeURIComponent(a.dataset.waMsg || 'Hola, vengo de muscleexpress.shop')}`;
  });

  document.addEventListener('click', e => {
    const b = e.target.closest('[data-stack]');
    if (!b) return;
    e.preventDefault();
    addStack(b.dataset.stack);
  });

  const page = document.body.dataset.page;
  const boot = {
    home: async () => { await initHome(); await pintaStacks('#stacks-home', 3); },
    catalogo: initCatalogo,
    producto: initProducto,
    paquetes: () => pintaStacks('#paquetes-todos'),
  }[page];
  boot?.().catch(err => {
    console.error(err);
    const t = $('#grid') || $('#ficha') || $('#destacados');
    if (t) t.innerHTML = `<p class="empty">No se pudo cargar el catálogo. Abre el sitio desde un servidor, no con doble clic en el archivo.</p>`;
  });

  paintCart();
});
